export default { "accessKeyId": "AKIAV7GSWDNGOHEQVEHU", "secretAccessKey": "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", "region": "us-east-1" }